// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"25094377","453":"dae5d000"}[chunkId] + ".chunk.js";
};